import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import { customWalk } from './helpers';


const queryElements = gql`
  query Elements($typeId: String, $projectId: String) {
    elements(typeId: $typeId, projectId: $projectId) {
      id,
      name,
      parent_id,
      order,
    }
  }
`;

const withData = compose(
  graphql(queryElements, {
    options: ({ wbsTypeId, currentProjectId }) => ({
      variables: {
        typeId: wbsTypeId,
        projectId: currentProjectId,
      },
      fetchPolicy: 'network-only',
    }),
  })
);

@withData
export default class WbsLayout extends Component {
  static propTypes = {
    rootElementId: PropTypes.string,
    data: PropTypes.object,
  }

  buildWbsData = () => {
    const {
      rootElementId,
      data: { elements },
    } = this.props;

    const WbsRootElement = elements.find(
      ele => ele.parent_id === rootElementId,
    );

    return WbsRootElement ?
      customWalk({
        flatData: elements,
        getKey: node => node.id,
        getParentKey: node => node.parent_id,
        rootKey: WbsRootElement.id,
        sortableTree: false,
      }) : [];
  }

  render() {
    const { data: { elements }, children } = this.props;
    if (!elements) return <div />;

    return (
      React.cloneElement(children, {
        ...this.props,
        orderedWbsElements: this.buildWbsData(),
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WbsLayout/WbsLayout.js